<template>
    <div class="accordion" id="faqAccordion">
        <div v-for="(item, index) in localizedFaqs" :key="index" class="accordion-item">
            <h2 class="accordion-header"
                @click="toggleAccordion(index)"
                :class="{ 'active-header': openedIndex === index }">
                <span v-html="item.question"></span>
                <img :src="openedIndex === index ? minusIcon : plusIcon" class="toggle-icon" alt="Toggle Icon">
            </h2>
            <div :id="'faq' + index" class="accordion-collapse collapse" 
                :class="{ 'show': openedIndex === index }" 
                data-bs-parent="#faqAccordion">
                <div class="accordion-body" v-html="item.answer">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Faq from "../../api/faq";
import plusIcon from "@/assets/images/faq/add.webp";
import minusIcon from "@/assets/images/faq/minus.webp";

export default {
    async created() {
        await this.fetchFaqs();
    },
    computed: {
        localizedFaqs() {
            return this.faqs.map(faq => {
                const translation = faq.translations.find(t => t.locale === this.locale);
                return {
                    question: translation ? translation.question : faq.question,
                    answer: translation ? translation.answer : faq.answer,
                };
            });
        }
    },
    data() {
        return {
            faqs: [],
            openedIndex: 0,
            locale: this.$i18n.locale,
            plusIcon,
            minusIcon
        };
    },
    watch: {
        '$i18n.locale'(newLocale) {
            this.locale = newLocale;
            this.fetchFaqs(); // Refetch FAQs when the locale changes
        }
    },
    methods: {
        async fetchFaqs() {
            let faq = await new Faq().GetAll({ per_page: 5 });
            this.faqs = faq.data;
        },
        toggleAccordion(index) {
            this.openedIndex = this.openedIndex === index ? null : index;
        }
    }
};
</script>

<style scoped>
/* Style for active/opened accordion header */
.active-header {
    background-color: #BF9F35 !important;
    color: white !important;
    font-weight: bold;
    cursor: pointer;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

h2 {
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.toggle-icon {
    width: 24px;
    height: 24px;
    margin-left: 10px;
}
</style>
